import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spin } from 'antd';
import {
  StyledCopyPreviousPopover,
  CopyWeekWarningContent,
  CopyWeekWarningText,
  CopyWeekWarningSubtext,
  CopyWeekWarningActions
} from './styled';

const CopyPreviousButton = (props) => {
  const {
    copyPreviousLoading,
    copyPreviousWarningOpen,
    onToggleWarning,
    onCopyWeek
  } = props;

  const handleCancelClick = (e) => {
    e.stopPropagation();
    onToggleWarning(false);
  };

  const handleTriggerClick = (e) => {
    // Prevent parent row click handlers from firing when opening the popover.
    e.stopPropagation();
  };

  const handleWarningContentClick = (e) => {
    e.stopPropagation();
  };

  const handleCopyWeek = (e) => {
    e.stopPropagation();
    onCopyWeek(e);
  };

  const handleOpenChange = (nextOpen) => {
    // Keep controlled state in sync so outside click closes the popover.
    onToggleWarning(nextOpen);
  };

  return (
    <StyledCopyPreviousPopover
      disabled={copyPreviousLoading}
      content={
        <CopyWeekWarningContent onClick={handleWarningContentClick}>
          <CopyWeekWarningText>This action will overwrite the current week&apos;s entries.</CopyWeekWarningText>
          <CopyWeekWarningSubtext>Entries from the previous week that are 0 will not overwrite the current week&apos;s entries.</CopyWeekWarningSubtext>
          <CopyWeekWarningActions>
            {copyPreviousLoading ? (
              <Spin size="small" />
            ) : (
              <>
                <Button onClick={handleCopyWeek}>Ok</Button>
                <Button onClick={handleCancelClick}>Cancel</Button>
              </>
            )}
          </CopyWeekWarningActions>
        </CopyWeekWarningContent>
      }
      title={copyPreviousLoading ? 'Copying...' : 'Copy Last Week'}
      trigger="click"
      open={copyPreviousWarningOpen}
      onOpenChange={handleOpenChange}
    >
      <Button onClick={handleTriggerClick} disabled={copyPreviousLoading}>
        {copyPreviousLoading ? 'Copying...' : 'Copy Last Week'}
      </Button>
    </StyledCopyPreviousPopover>
  );
};

CopyPreviousButton.propTypes = {
  copyPreviousLoading: PropTypes.bool,
  copyPreviousWarningOpen: PropTypes.bool,
  onToggleWarning: PropTypes.func,
  onCopyWeek: PropTypes.func
};

CopyPreviousButton.defaultProps = {
  copyPreviousLoading: false,
  copyPreviousWarningOpen: false,
  onToggleWarning: () => {},
  onCopyWeek: () => {}
};

export default CopyPreviousButton;